export default "__VITE_ASSET__BfTKi0f3__"